<template>
  <div class="lpMainDiv">
    <div class="col-12" style="padding: 0">
      <div style="margin-bottom: 35px">
        <div class="d-flex" style="justify-content: space-between">
          <div class="summaryCls" v-if="context == 'gp'">Summary</div>
          <div class="summaryCls" v-if="context == 'lp'">Fund Details</div>
          <!-- <button class="newTask" @click="updateSummary">Update</button> -->
        </div>
        <div class="row w-100 ml-0 mr-0" style="margin-top: 20px">
          <div class="col-6 pl-0">
            <div class="row w-100 ml-0 mr-0 summaryFundCardLayout">
              <div class="col-4 pl-0 pr-0" style="margin-top: 35px">
                <div style="border-right: 1px solid #30334c; height: 120px">
                  <div
                    class="d-flex justify-content-center"
                    style="padding-top: 30px; padding-bottom: 15px"
                  >
                    <div class="summaryFundTitle">Fund Size</div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <div class="summaryFundTitle">{{ fundSizeValue }}</div>
                  </div>
                </div>
              </div>
              <div
                class="col-8"
                style="
                  margin-top: 35px;
                  padding-left: 60px;
                  padding-right: 60px;
                "
              >
                <table class="summaryCallTable">
                  <tr v-for="field in summaryCallFields" :key="field.label">
                    <th v-if="field.label == 'Last % Capital Called'">
                      <div class="d-flex">
                        <div>Last % Capital Called</div>
                        <div style="margin-left: 8px">
                          <span style="margin-left: 3px">:</span>
                        </div>
                      </div>
                    </th>
                    <th v-else-if="field.label == 'Capital Called to Date : '">
                      <div class="d-flex">
                        <div>Capital Called to Date</div>
                        <div style="margin-left: 8px">
                          <span style="margin-left: 3px">:</span>
                        </div>
                      </div>
                    </th>

                    <th style="width: 200px" v-else>{{ field.label }}</th>

                    <td v-if="field.label == 'Last % Capital Called'">
                      <span id="capCallAmtId" class="pointer">{{ field.value }}</span>
                      <b-popover
                        target="capCallAmtId"
                        triggers="hover"
                        placement="topright"
                        custom-class
                      >
                        <div class="">
                          {{ toolTipInfo("capital_called_amount") }}
                        </div>
                      </b-popover>
                    </td>
                    <td v-else-if="field.label == 'Capital Called to Date : '">
                      <span id="capCallDtId" class="pointer">{{ field.value }}</span>
                      <b-popover
                        target="capCallDtId"
                        triggers="hover"
                        placement="topright"
                        custom-class
                      >
                        <div class="">
                          {{ toolTipInfo("capital_called_to_date_amount") }}
                        </div>
                      </b-popover>
                    </td>
                    <td v-else>{{ field.value }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="col-6 pr-0">
            <div class="row w-100 ml-0 mr-0 summaryFundCardLayout">
              <div
                class="col-12"
                style="margin-top: 10px; cursor: pointer"
                v-if="context == 'lp'"
                @click="handleUpdateFundKpi"
              >
                <div class="d-flex justify-content-end">
                  <div class="updateLpKpi">Update</div>
                </div>
              </div>
              <div
                class="col-7 pl-0 pr-0"
                :style="
                  context == 'gp' ? 'margin-top: 35px' : 'margin-top:10px'
                "
              >
                <div style="border-right: 1px solid #30334c; height: 120px">
                  <div
                    class="d-flex justify-content-center"
                    style="padding-top: 30px; padding-bottom: 15px"
                  >
                    <div class="summaryFundTitle" v-if="context == 'gp'">
                      Distributed to Date
                    </div>
                    <div class="summaryFundTitle" v-if="context == 'lp'">
                      Total Distributed
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <div class="summaryFundTitle">
                      {{ distributedToDateValue }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-5"
                :style="
                  context == 'gp'
                    ? 'margin-top: 35px;padding-left: 40px;padding-right: 40px;'
                    : 'margin-top:10px;padding-left: 40px;padding-right: 40px;'
                "
              >
                <table class="summaryCallTable distributionTableLayout">
                  <tr
                    v-for="field in distributionCallFields"
                    :key="field.label"
                  >
                    <th>{{ field.label }}</th>
                    <td>{{ field.value }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div id="theMainTableSummary">
          <div
            class="tabulator lp-tabulator-cls"
            ref="summaryRefTable"
            style="width:100%;height:100%"
          ></div>
        </div>-->
      </div>
      <div>
        <div
          class="d-flex pb-2"
          style="justify-content: space-between"
          v-if="context == 'gp'"
        >
          <div class="summaryCls">LP Details</div>
          <button class="newTask" @click="addDetails" v-if="showAddButton">
            <i class="fa fa-plus" aria-hidden="true"></i>
            Add
          </button>
        </div>
        <div v-if="context == 'lp'">
          <div class="summaryCls" style="font-size: 20px">LP Details</div>
          <div
            style="
              border-top: 2px solid #00000033;
              margin-top: 10px;
              margin-bottom: 20px;
            "
          ></div>
          <div class="d-flex justify-content-end" style="margin-bottom: 15px">
            <button class="newTask" @click="addDetails" v-if="showAddButton">
              <i class="fa fa-plus" aria-hidden="true"></i>
              Add
            </button>
          </div>
        </div>
        <div id="theMainTableSummary">
          <div
            class="tabulator lp-tabulator-cls"
            ref="detailsRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div style="margin-top: 30px" v-if="context == 'gp'">
        <div class="summaryCls" style="margin-bottom: 20px">GP Details</div>
        <div id="theMainTableSummary">
          <div
            class="tabulator lp-tabulator-cls"
            ref="gpDetailsRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div style="margin-top: 30px" v-if="context == 'gp'">
        <div class="summaryCls" style="margin-bottom: 20px">Fund Details</div>
        <div id="theMainTableSummary">
          <div
            class="tabulator lp-tabulator-cls fundDetailsTabulator"
            ref="fundDetailsRefTable"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div style="margin-top: 22px" v-if="context == 'lp'">
        <div class="row ml-0 mr-0 w-100">
          <div class="col-6 pl-0 pr-0">
            <!-- <div class="summaryCls" style="">Calls</div> -->
            <CapitalCallTab
              ref="capitalCallRef"
              :context="'lp'"
            ></CapitalCallTab>
          </div>
          <div class="col-6 pr-0">
            <!-- <div class="summaryCls" style="">Distributions</div> -->
            <DistributionsTab
              ref="distributionRef"
              :context="'lp'"
            ></DistributionsTab>
          </div>
        </div>
      </div>
    </div>
    <DialogAddLp
      v-model="dialogDetailsData"
      @emit-success="refreshDetailsData"
      v-if="showDetailsModal"
    ></DialogAddLp>
    <DialogUpdateSummary
      v-model="dialogSummaryData"
      @emit-success="refreshSummaryData"
      v-if="showSummaryModal"
    ></DialogUpdateSummary>
    <custom-menu></custom-menu>
    <el-dialog
      center
      width="410px"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelDeleteDetail"
      :showClose="!showDetailDeleteSpinner"
      :visible.sync="showDeleteDetailDialog"
    >
      <div class="row" style="padding-left: 15px; padding-right: 15px">
        <div style="padding-left: 30px">
          Are you sure you want to Delete this Detail?
        </div>
      </div>
      <div class="col-12 d-flex">
        <div
          class="col-xl edit-company-action-button-row"
          style="padding-right: 25px"
        >
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancelDeleteDetail"
            :disabled="showDetailDeleteSpinner"
          >
            Cancel
          </button>
          <button
            type="submit"
            @click.prevent="handleDeleteDetail(deleteDetailData)"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
            :disabled="showDetailDeleteSpinner"
          >
            Delete
            <b-spinner
              v-if="showDetailDeleteSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      left
      title="Edit GP Details"
      width="410px"
      style="margin: 0 auto"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelEditGpDetail"
      :showClose="true"
      :visible.sync="showEditGPDetailsModal"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="handleEditGpDetails">
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Contributed to Date</div>
            <input
              type="number"
              min="0"
              step=".01"
              class="form-control team-form"
              style="width: 100%"
              v-model="editGPDetailsData.contributed_to_date"
              placeholder="Contributed to Date"
            />
          </div>
        </div>
        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            @click="handleCancelEditGpDetail()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="showEditGPDetailsSpinner"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="showEditGPDetailsSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
    <el-dialog
      left
      title="Edit "
      width="410px"
      style="margin: 0 auto"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      @close="handleCancelFundKpi"
      :showClose="true"
      :visible.sync="showUpdateFundKpiModal"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="handleSaveUpdateFundKpi">
        <div class="row">
          <div class="col-12">
            <div class="formLabel">MOIC</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_moic"
              placeholder="MOIC"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Net TVPI</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_tvpi"
              placeholder="Net TVPI"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Net DPI</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_dpi"
              placeholder="Net DPI"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">IRR</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_irr"
              placeholder="IRR"
              min="0"
              max="100"
              step=".01"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Total Distributed</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_distributed"
              placeholder="Total Distributed"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">No.of Companies</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_no_of_companies"
              placeholder="No.of Companies"
              min="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Exits</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_exits"
              placeholder="Exists"
              min="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="formLabel">Value of Portfolio</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="updateFundKpiData.fund_value_of_portfolio"
              placeholder="Value of Portfolio"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            @click="handleCancelFundKpi()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!--  @click="handleSaveUpdateFundKpi" -->
          <button
            type="submit"
            :disabled="showUpdateFundKpiSpinner"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="showUpdateFundKpiSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Tabulator from "tabulator-tables";
import CustomMenu from "../Components/CustomMenu.vue";
import DialogAddLp from "../Dialogs/DialogAddLp";
import DialogUpdateSummary from "../Dialogs/DialogUpdateSummary";
import { mapGetters } from "vuex";
import { Dialog, Select, Option } from "element-ui";
import {
  formatCurrency,
  formatNumber,
  precisionNumberForamtter,
} from "../../../util";
import CapitalCallTab from "./CapitalCallTab";
import DistributionTab from "./DistributionsTab";
import api from "../../../axios_api";
export default {
  name: "lpAllocation",
  components: {
    [CustomMenu.name]: CustomMenu,
    DialogAddLp,
    DialogUpdateSummary,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
    [CapitalCallTab.name]: CapitalCallTab,
    [DistributionTab.name]: DistributionTab,
  },
  props: {
    context: String,
  },
  computed: {
    ...mapGetters("lpAllocations", ["summaryData"]),
    ...mapGetters("lpAllocations", [
      "detailsData",
      "lpDetailsData",
      "gpDetailsData",
      "fundDetailsData",
      "currentCapitalCallData",
    ]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("lpAllocations", ["thesisData"]),
    ...mapGetters("user", ["currency"]),
    ...mapGetters("role", ["checkRole"]),
    summary() {
      return {
        data: this.summaryData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        // index: "_id",
        tooltips: true,
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.summaryTableColumns,
      };
    },
    details() {
      return {
        //data: this.detailsData,
        data: this.lpDetailsData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        //pagination: "local",
        //paginationSize: 10,
        index: "_id",
        //paginationSizeSelector: true,
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.detailsTableColumns,
      };
    },
    gpDetails() {
      return {
        data: this.gpDetailsData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        headerVisible: false,
        index: "_id",
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.gpDetailsTableColumns,
      };
    },
    fundDetails() {
      return {
        data: this.fundDetailsData,
        layout: "fitColumns",
        tooltips: true,
        layoutColumnsOnNewData: true,
        headerVisible: false,
        index: "_id",
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: this.fundDetailsTableColumns,
      };
    },
    summaryTableColumns() {
      const self = this;
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                let data = _cell.getData();
              },
            },
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      return [
        // {
        //   title: "Metric",
        //   field: "metric",
        //   headerSort: false,
        //   resizable: true,
        // },
        {
          title: "Fund Size",
          field: "capital_commitment",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Last Cap Call Date",
          field: "last_call",
          resizable: true,
          headerSort: false,
          sorter: "date",
          formatter: function (cell, formatterParams) {
            return moment(cell.getData().last_call).format("MM/DD/YYYY");
          },
        },
        {
          title: "Last $ Capital Called",
          field: "capital_called",
          resizable: true,
          headerSort: false,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Capital Called to Date",
          field: "capital_called_to_date",
          resizable: true,
          headerSort: false,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Capital Deployed to Date",
          field: "capital_deployed",
          resizable: true,
          headerSort: false,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Current Distribution",
          field: "distributions",
          resizable: true,
          headerSort: false,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Distributed to Date",
          field: "distributed_to_date",
          resizable: true,
          headerSort: false,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        // {
        //   title: "Management Fees",
        //   field: "management_fees",
        //   resizable: true,
        //   headerSort: false,
        //   formatter: "money",
        //   formatterParams: this.currency.format,
        // },
        // {
        //   title: "Carry",
        //   field: "carry",
        //   resizable: true,
        //   headerSort: false,
        //   formatter: "money",
        //   formatterParams: this.currency.format,
        // },
        {
          title: "MOIC",
          field: "moic",
          resizable: true,
          headerSort: false,
        },
        {
          title: "Gross TVPI",
          field: "tvpi",
          resizable: true,
          headerSort: false,
        },
        {
          title: "Net DPI",
          field: "net_dpi",
          resizable: true,
          headerSort: false,
        },
        {
          title: "Gross DPI",
          field: "gross_dpi",
          resizable: true,
          headerSort: false,
        },
        // {
        //   title: "IRR",
        //   field: "irr",
        //   resizable: true,
        //   headerSort: false,
        // },
        // {
        //   width: "20",
        //   resizable: false,
        //   headerSort: false,
        //   responsive: 0,
        //   download: false,
        //   formatter: handleMenu,
        // },
      ];
    },
    detailsTableColumns() {
      const self = this;
      let retval = [];
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          const ctxMenuData = [
            {
              title: "Edit",
              handler: () => {
                let data = _cell.getData();
                self.editDetails(data);
              },
            },
            {
              title: "Delete",
              handler: () => {
                let data = _cell.getData();
                self.deleteDetailData = data;
                self.showDeleteDetailDialog = true;
              },
            },
          ];
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `;
      };
      if (self.context == "gp") {
        retval = [
          {
            title: "NO.",
            field: "indexNumber",
            headerSort: false,
            resizable: true,
            bottomCalc: function (values, data, calcParams) {
              //values - array of column values
              //data - all table data
              //calcParams - params passed from the column definition object
              let retval =
                self.context == "gp"
                  ? data &&
                    data.length > 0 &&
                    data[0].hasOwnProperty("entity_type") &&
                    data[0].entity_type.length > 0
                    ? data[0].entity_type == "LP"
                      ? "LP TOTALS"
                      : "GP TOTALS"
                    : "TOTALS"
                  : "TOTALS";
              return retval;
            },
          },
          {
            title: "Entity Name",
            field: "entity_name",
            headerSort: false,
            resizable: true,
          },
          // {
          //   title: "Entity Type",
          //   field: "entity_type",
          //   headerSort: false,
          //   resizable: true,
          // },
          {
            title: "Capital Commitment",
            field: "capital_commitment",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          {
            title: "Fund Ownership %",
            field: "ownership",
            headerSort: false,
            resizable: true,
            // bottomCalc: "sum",
            // bottomCalcParams: { precision: 2 },
            bottomCalc: function (values, data, calcParams) {
              //values - array of column values
              //data - all table data
              //calcParams - params passed from the column definition object
              let retval = 0;
              data.map((item) => {
                if (
                  item &&
                  item.hasOwnProperty("ownership") &&
                  Number(item.ownership) > 0
                ) {
                  retval += Number(item.ownership);
                }
              });
              return `${Number(retval).toFixed(2)}%`;
            },
          },
          {
            title: "LP %",
            field: "lp_percentage",
            headerSort: false,
            resizable: true,
            resizable: true,
            // bottomCalc: "sum",
            // bottomCalcParams: { precision: 2 },
            bottomCalc: function (values, data, calcParams) {
              //values - array of column values
              //data - all table data
              //calcParams - params passed from the column definition object
              let retval = 0;
              data.map((item) => {
                if (
                  item &&
                  item.hasOwnProperty("lp_percentage") &&
                  Number(item.lp_percentage) > 0
                ) {
                  retval += Number(item.lp_percentage);
                }
              });
              return `${Number(retval).toFixed(2)}%`;
            },
          },
          {
            title: "Profit %",
            field: "profit",
            headerSort: false,
            resizable: true,
            resizable: true,
            // bottomCalc: "sum",
            // bottomCalcParams: { precision: 2 },
            bottomCalc: function (values, data, calcParams) {
              //values - array of column values
              //data - all table data
              //calcParams - params passed from the column definition object
              let retval = 0;
              data.map((item) => {
                if (
                  item &&
                  item.hasOwnProperty("profit") &&
                  Number(item.profit) > 0
                ) {
                  retval += Number(item.profit);
                }
              });
              return `${Number(retval).toFixed(2)}%`;
            },
          },
          {
            title: "Total Capital Called",
            field: "capital_called",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          {
            title: "Capital Contributed to Date",
            field: "contributed_to_date",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          {
            title: "Receivable/Pre-paid Balance",
            field: "open_balance",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          {
            title: "Remaining Commitment",
            field: "remaining_commitment",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          {
            title: "Distributions",
            field: "distributions",
            headerSort: false,
            resizable: true,
            formatter: "money",
            formatterParams: this.currency.format,
            bottomCalc: "sum",
            bottomCalcFormatter: "money",
            bottomCalcFormatterParams: this.currency.format,
            bottomCalcParams: { precision: 2 },
          },
          // {
          //   title: "Share Of Carried Cash",
          //   field: "share_of_carried_cash",
          //   headerSort: false,
          //   resizable: true,
          // },
          // {
          //   title: "Profit %",
          //   field: "profit",
          //   headerSort: false,
          //   resizable: true,
          // },
          {
            width: "20",
            resizable: false,
            headerSort: false,
            download: false,
            //formatter: handleMenu,
            formatter: function (_cell, formatterParams) {
              const self = this;
              if (
                _cell.getData() &&
                _cell.getData().hasOwnProperty("entity_type") &&
                _cell.getData().entity_type == "LP"
              ) {
                return handleMenu(_cell, formatterParams, formatterParams);
              } else {
                return "";
              }
            },
          },
        ];
        if (self.checkRole == "Guest") {
          retval.pop();
        }
        return retval;
      } else {
        if (self.context == "lp") {
          retval = [
            {
              title: "Entity Name",
              field: "entity_name",
              headerSort: false,
              resizable: true,
            },
            {
              title: "Capital Commitment",
              field: "capital_commitment",
              headerSort: false,
              resizable: true,
              formatter: "money",
              formatterParams: this.currency.format,
            },
            // {
            //   title: "Total Capital Called",
            //   field: "capital_called",
            //   headerSort: false,
            //   resizable: true,
            //   formatter: "money",
            //   formatterParams: this.currency.format,
            // },
            {
              title: "Capital Contributed to Date",
              field: "contributed_to_date",
              headerSort: false,
              resizable: true,
              formatter: "money",
              formatterParams: this.currency.format,
            },
            {
              title: "Owed/Pre-paid Balance",
              field: "open_balance",
              headerSort: false,
              resizable: true,
              formatter: "money",
              formatterParams: this.currency.format,
            },
            {
              title: "Un Called",
              field: "remaining_commitment",
              headerSort: false,
              resizable: true,
              formatter: "money",
              formatterParams: this.currency.format,
            },
            // {
            //   title: "Distributions",
            //   field: "distributions",
            //   headerSort: false,
            //   resizable: true,
            //   formatter: "money",
            //   formatterParams: this.currency.format,
            // },
            {
              width: "20",
              resizable: false,
              headerSort: false,
              download: false,
              //formatter: handleMenu,
              formatter: function (_cell, formatterParams) {
                const self = this;
                if (
                  _cell.getData() &&
                  _cell.getData().hasOwnProperty("entity_type") &&
                  _cell.getData().entity_type == "LP"
                ) {
                  return handleMenu(_cell, formatterParams, formatterParams);
                } else {
                  return "";
                }
              },
            },
          ];
          if (self.checkRole == "Guest") {
            retval.pop();
          }
          return retval;
        }
      }
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
    fundDetailsTableColumns() {
      const self = this;
      return [
        {
          title: "Entity Name",
          field: "entity_name",
          headerSort: false,
          resizable: true,
        },
        {
          title: "Entity Type",
          field: "entity_type",
          headerSort: false,
          resizable: true,
        },
        {
          title: "Capital Commitment",
          field: "capital_commitment",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Ownership (%)",
          field: "ownership",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return `${Number(cell.getData().ownership).toFixed(1)}%`;
          },
        },
        {
          title: "LP %",
          field: "lp_percentage",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return `${Number(cell.getData().lp_percentage).toFixed(1)}%`;
          },
        },
        {
          title: "Profit %",
          field: "profit",
          headerSort: false,
          resizable: true,
          formatter: function (cell, formatterParams) {
            return `${Number(cell.getData().profit).toFixed(1)}%`;
          },
        },
        {
          title: "Capital Called",
          field: "capital_called",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Contributed To Date",
          field: "contributed_to_date",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Open Balance",
          field: "open_balance",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Remaining Commitment",
          field: "remaining_commitment",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Distributions",
          field: "distributions",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
        },
        // {
        //   title: "Share Of Carried Cash",
        //   field: "share_of_carried_cash",
        //   headerSort: false,
        //   resizable: true,
        // },
        // {
        //   title: "Profit %",
        //   field: "profit",
        //   headerSort: false,
        //   resizable: true,
        // },
        {
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
        },
      ];
    },
    gpDetailsTableColumns() {
      const self = this;
      let retval = [];
      let handleMenu = function (_cell, a, b) {
        _cell.getElement().addEventListener("click", () => {
          let ctxMenuData = [];
          if (
            _cell.getData() &&
            _cell.getData().hasOwnProperty("entity_type") &&
            _cell.getData().entity_type == "GP"
          ) {
            ctxMenuData = [
              {
                title: "Edit",
                handler: () => {
                  let data = _cell.getData();
                  self.editGPDetails(data);
                },
              },
            ];
          }
          self.$root.$emit("contextmenu", { event, ctxMenuData });
        });

        return _cell.getData() &&
          _cell.getData().hasOwnProperty("entity_type") &&
          _cell.getData().entity_type == "GP"
          ? `
        <i class="fas fa-ellipsis-v" style="color:#0000004D;"></i>
        `
          : "";
      };
      retval = [
        {
          title: "Entity Name",
          field: "entity_name",
          headerSort: false,
          resizable: true,
          bottomCalc: function (values, data, calcParams) {
            //values - array of column values
            //data - all table data
            //calcParams - params passed from the column definition object
            let retval =
              data &&
              data.length > 0 &&
              data[0].hasOwnProperty("entity_type") &&
              data[0].entity_type.length > 0
                ? data[0].entity_type == "LP"
                  ? "LP TOTALS"
                  : "GP TOTALS"
                : "TOTALS";
            return retval;
          },
        },
        {
          title: "Entity Type",
          field: "entity_type",
          headerSort: false,
          resizable: true,
        },
        {
          title: "Capital Commitment",
          field: "capital_commitment",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        {
          title: "Fund Ownership %",
          field: "ownership",
          headerSort: false,
          resizable: true,
          // bottomCalc: "sum",
          // bottomCalcParams: { precision: 2 },
          bottomCalc: function (values, data, calcParams) {
            //values - array of column values
            //data - all table data
            //calcParams - params passed from the column definition object
            let retval = 0;
            data.map((item) => {
              if (
                item &&
                item.hasOwnProperty("ownership") &&
                Number(item.ownership) > 0
              ) {
                retval += Number(item.ownership);
              }
            });
            return `${Number(retval).toFixed(2)}%`;
          },
        },
        {
          title: "LP %",
          field: "lp_percentage",
          headerSort: false,
          resizable: true,
          resizable: true,
          // bottomCalc: "sum",
          // bottomCalcParams: { precision: 2 },
          bottomCalc: function (values, data, calcParams) {
            //values - array of column values
            //data - all table data
            //calcParams - params passed from the column definition object
            let retval = 0;
            data.map((item) => {
              if (
                item &&
                item.hasOwnProperty("lp_percentage") &&
                Number(item.lp_percentage) > 0
              ) {
                retval += Number(item.lp_percentage);
              }
            });
            return `${Number(retval).toFixed(2)}%`;
          },
        },
        {
          title: "Profit %",
          field: "profit",
          headerSort: false,
          resizable: true,
          resizable: true,
          // bottomCalc: "sum",
          // bottomCalcParams: { precision: 2 },
          bottomCalc: function (values, data, calcParams) {
            //values - array of column values
            //data - all table data
            //calcParams - params passed from the column definition object
            let retval = 0;
            data.map((item) => {
              if (
                item &&
                item.hasOwnProperty("profit") &&
                Number(item.profit) > 0
              ) {
                retval += Number(item.profit);
              }
            });
            return `${Number(retval).toFixed(2)}%`;
          },
        },
        {
          title: "Last $ Capital Called",
          field: "capital_called",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        {
          title: "Contributed To Date",
          field: "contributed_to_date",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        {
          title: "Receivable/(Pre-paid Balance)",
          field: "open_balance",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        {
          title: "Remaining Commitment",
          field: "remaining_commitment",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        {
          title: "Distributions",
          field: "distributions",
          headerSort: false,
          resizable: true,
          formatter: "money",
          formatterParams: this.currency.format,
          bottomCalc: "sum",
          bottomCalcFormatter: "money",
          bottomCalcFormatterParams: this.currency.format,
          bottomCalcParams: { precision: 2 },
        },
        // {
        //   title: "Share Of Carried Cash",
        //   field: "share_of_carried_cash",
        //   headerSort: false,
        //   resizable: true,
        // },
        // {
        //   title: "Profit %",
        //   field: "profit",
        //   headerSort: false,
        //   resizable: true,
        // },
        {
          width: "20",
          resizable: false,
          headerSort: false,
          responsive: 0,
          download: false,
          formatter: function (_cell, formatterParams) {
            const self = this;
            if (
              _cell.getData() &&
              _cell.getData().hasOwnProperty("entity_type") &&
              _cell.getData().entity_type == "GP"
            ) {
              return handleMenu(_cell, formatterParams, formatterParams);
            } else {
              return "";
            }
          },
        },
      ];
      if (self.checkRole == "Guest") {
        retval.pop();
      }
      return retval;
    },
    fundSizeValue() {
      if (this.context == "gp") {
        let data = this.$store.getters["lpAllocations/fundDetailsData"];

        let retval =
          data &&
          data.length > 0 &&
          data[0].hasOwnProperty("capital_commitment") &&
          Number(data[0].capital_commitment) > 0
            ? `$${this.precisionNumberForamtter(
                Number(data[0].capital_commitment),
                1
              )}`
            : "$0";
        return retval;
      } else {
        if (this.context == "lp");
        let data =
          this.thesisData && this.thesisData.length > 0
            ? this.thesisData[0]
            : {};
        let retval =
          data.hasOwnProperty("size") && Number(data.size) > 0
            ? `$${this.precisionNumberForamtter(Number(data.size), 1)}`
            : "$0";
        return retval;
      }
    },
    fundSizeValueActual() {
      if (this.context == "gp") {
        let data = this.$store.getters["lpAllocations/fundDetailsData"];
        let retval =
          data &&
          data.length > 0 &&
          data[0].hasOwnProperty("capital_commitment") &&
          Number(data[0].capital_commitment) > 0
            ? Number(data[0].capital_commitment)
            : 0;
        return retval;
      } else {
        if (this.context == "lp");
        let data =
          this.thesisData && this.thesisData.length > 0
            ? this.thesisData[0]
            : {};
        let retval =
          data.hasOwnProperty("size") && Number(data.size) > 0
            ? Number(data.size)
            : 0;
        return retval;
      }
    },
    summaryCallFields() {
      let data = this.summaryData;
      let currentCapitalCallData = this.currentCapitalCallData;
      let retval = [
        {
          label: "Capital Deployed to Date : ",
          value:
            this.portfolioCost && Number(this.portfolioCost) > 0
              ? formatCurrency(
                  Number(this.portfolioCost),
                  this.currency.ref,
                  0,
                  true
                )
              : "$0",
        },
        {
          label: "Capital Called to Date : ",
          value:
            data &&
            data.length > 0 &&
            data[0].hasOwnProperty("capital_called_to_date") &&
            Number(data[0].capital_called_to_date) > 0
              ? `${Number(data[0].capital_called_to_date)}%`
              : "0%",
        },
        {
          label: "Last Cap Call Date : ",
          value:
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("last_call")
              ? moment(currentCapitalCallData.last_call).format("MM-DD-YYYY")
              : "-",
        },
        {
          label: "Last % Capital Called",
          value:
            data &&
            data.length > 0 &&
            data[0].hasOwnProperty("capital_called") &&
            Number(data[0].capital_called) > 0
              ? `${Number(Number(data[0].capital_called).toFixed(2))}%`
              : "0%",
        },
        {
          label: "Target Capital To Deploy : ",
          value:
            (this.portfolioCost && this.fundSizeValueActual
              ? Number(this.portfolioCost / this.fundSizeValueActual).toFixed(2)
              : 0) + "x",
        },
      ];

      return retval;
    },
    distributedToDateValue() {
      if (this.context == "gp") {
        let data = this.summaryData;
        let retval =
          data &&
          data.length > 0 &&
          data[0].hasOwnProperty("distributed_to_date") &&
          Number(data[0].distributed_to_date) > 0
            ? `$${precisionNumberForamtter(
                Number(data[0].distributed_to_date),
                1
              )}`
            : `$0`;
        return retval;
      } else {
        if (this.context == "lp") {
          let data =
            this.fundKpiData && this.fundKpiData.length > 0
              ? this.fundKpiData[0]
              : {};
          return data.fund_distributed && data.fund_distributed > 0
            ? `$${precisionNumberForamtter(Number(data.fund_distributed), 1)}`
            : `$0`;
        }
      }
    },
    distributionCallFields() {
      if (this.context == "gp") {
        let data = this.summaryData;
        let retval = [
          {
            label: "MOIC : ",
            // value:
            //   data &&
            //   data.length > 0 &&
            //   data[0].hasOwnProperty("moic") &&
            //   Number(data[0].moic) > 0
            //     ? Number(Number(data[0].moic).toFixed(2))
            //     : 0,
            value: this.moicValue,
          },
          {
            label: "Gross TVPI : ",
            // value:
            //   data &&
            //   data.length > 0 &&
            //   data[0].hasOwnProperty("tvpi") &&
            //   Number(data[0].tvpi) > 0
            //     ? Number(Number(data[0].tvpi).toFixed(2))
            //     : 0,
            value: this.tvpiValue,
          },
          {
            label: "Net DPI : ",
            value:
              data &&
              data.length > 0 &&
              data[0].hasOwnProperty("net_dpi") &&
              Number(data[0].net_dpi) > 0
                ? Number(Number(data[0].net_dpi).toFixed(2))
                : 0,
          },
          {
            label: "Gross DPI : ",
            value:
              data &&
              data.length > 0 &&
              data[0].hasOwnProperty("gross_dpi") &&
              Number(data[0].gross_dpi) > 0
                ? Number(Number(data[0].gross_dpi).toFixed(2))
                : 0,
          },
        ];
        return retval;
      } else {
        if (this.context == "lp") {
          let data =
            this.fundKpiData && this.fundKpiData.length > 0
              ? this.fundKpiData[0]
              : {};
          let retval = [
            {
              label: "MOIC : ",
              value: data.fund_moic && data.fund_moic > 0 ? data.fund_moic : 0,
            },
            {
              label: "Net TVPI : ",
              value: data.fund_tvpi && data.fund_tvpi > 0 ? data.fund_tvpi : 0,
            },
            {
              label: "Net DPI : ",
              value: data.fund_dpi && data.fund_dpi > 0 ? data.fund_dpi : 0,
            },
            {
              label: "IRR : ",
              value: data.fund_irr && data.fund_irr > 0 ? data.fund_irr : 0,
            },
          ];
          return retval;
        }
      }
    },
    moicValue() {
      return this.portfolioCost && this.portfolioCost > 0
        ? Number(
            (Number(this.portfolioValue) / Number(this.portfolioCost)).toFixed(
              2
            )
          )
        : 0;
    },
    tvpiValue() {
      let totalLpCapitalCalled = 0;
      let lpDetailsData = JSON.parse(JSON.stringify(this.lpDetailsData));
      if (lpDetailsData && lpDetailsData.length > 0) {
        lpDetailsData.map((item) => {
          if (
            item &&
            item.hasOwnProperty("capital_called") &&
            Number(item.capital_called) > 0
          ) {
            totalLpCapitalCalled += Number(item.capital_called);
          }
        });
      }
      return Number(totalLpCapitalCalled) > 0
        ? Number(
            (
              Number(this.portfolioValue) / Number(totalLpCapitalCalled)
            ).toFixed(2)
          )
        : 0;
    },
    showAddButton() {
      if (this.checkRole == "Guest") {
        return false;
      }
      if (this.context == "gp") {
        return true;
      } else {
        return this.lpDetailsData.length > 0 ? false : true;
      }
    },
  },
  watch: {
    summary: {
      handler: function (newData) {
        if (this.summaryTabulator) {
          //this.summaryTabulator.replaceData(this.summary.data);
        }
      },
    },
    details: {
      handler: function (newData) {
        if (this.detailsTabulator) {
          this.detailsTabulator.replaceData(this.details.data);
        }
        if (this.gpDetailsTabulator) {
          this.gpDetailsTabulator.replaceData(this.gpDetails.data);
        }
        if (this.fundDetailsTabulator) {
          this.fundDetailsTabulator.replaceData(this.fundDetails.data);
        }
      },
    },
  },
  data() {
    return {
      summaryTabulator: null,
      detailsTabulator: null,
      dialogSummaryData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      dialogDetailsData: {
        isShow: false,
        data: {},
        isCreate: true,
      },
      showSummaryModal: false,
      showDetailsModal: false,
      showDeleteDetailDialog: false,
      showDetailDeleteSpinner: false,
      deleteDetailData: {},
      gpDetailsTabulator: null,
      fundDetailsTabulator: null,
      editGPDetailsData: {},
      showEditGPDetailsModal: false,
      showEditGPDetailsSpinner: false,
      fundKpiData: [],
      showUpdateFundKpiModal: false,
      showUpdateFundKpiSpinner: false,
      updateFundKpiData: {},
    };
  },
  mounted() {
    // if (this.$refs.summaryRefTable && this.summary) {
    //   this.summaryTabulator = new Tabulator(
    //     this.$refs.summaryRefTable,
    //     this.summary
    //   );
    // }
    const self = this;
    // setTimeout(() => {
    if (self.$refs.detailsRefTable && self.details) {
      self.detailsTabulator = new Tabulator(
        self.$refs.detailsRefTable,
        self.details
      );
    }
    if (self.$refs.gpDetailsRefTable && self.gpDetails) {
      self.gpDetailsTabulator = new Tabulator(
        self.$refs.gpDetailsRefTable,
        self.gpDetails
      );
    }
    if (self.$refs.fundDetailsRefTable && self.fundDetails) {
      self.fundDetailsTabulator = new Tabulator(
        self.$refs.fundDetailsRefTable,
        self.fundDetails
      );
    }
    // },3000);
    if (this.context && this.context == "lp") {
      this.getFundKpi();
    }

    this.$store.dispatch("lpAllocations/apiFetchDetailsData").then((d) => {});
  },
  methods: {
    refreshSummaryData() {
      const self = this;
      let data = self.$store.getters["lpAllocations/summaryData"];
      //if (data && data.length > 0) this.summaryTabulator.replaceData(data);
      this.showSummaryModal = false;
    },
    updateSummary() {
      const self = this;
      self.dialogSummaryData = {
        isShow: true,
        data:
          self.summaryData && self.summaryData.length > 0
            ? self.summaryData[0]
            : {},
        isCreate: true,
        portfolioCost: self.portfolioValue,
        portfolioValue: self.portfolioCost,
        detailsData: self.detailsData,
        summaryData:
          self.summaryData && self.summaryData.length > 0
            ? self.summaryData[0]
            : {},
      };
      // self.dialogSummaryData.data.capital_deployed =
      //   self.portfolioCost && Number(self.portfolioCost) > 0
      //     ? Number(self.portfolioCost)
      //     : 0;
      self.dialogSummaryData.data.capital_deployed = self.calculateCapitalDeployedOfSummary();
      if (
        self.thesisData &&
        self.thesisData.length > 0 &&
        self.thesisData[0].size
      ) {
        self.dialogSummaryData.data.capital_commitment =
          self.thesisData[0].size;
      }
      if (self.dialogSummaryData.data.capital_commitment) {
        self.dialogSummaryData.data.management_fees = Number(
          self.dialogSummaryData.data.capital_commitment
        )
          ? (2 / 100) * Number(self.dialogSummaryData.data.capital_commitment)
          : 0;
      }
      if (!self.dialogSummaryData.data.hasOwnProperty("distributed_to_date")) {
        self.dialogSummaryData.data.distributed_to_date = 0;
      }
      // self.dialogSummaryData.data.moic =
      //   self.dialogSummaryData.data.capital_deployed &&
      //   Number(self.dialogSummaryData.data.capital_deployed) > 0
      //     ? (
      //         Number(
      //           Number(self.dialogSummaryData.data.distributed_to_date) -
      //             Number(self.dialogSummaryData.data.capital_deployed)
      //         ) / Number(self.dialogSummaryData.data.capital_deployed)
      //       ).toFixed(2)
      //     : 0;
      self.dialogSummaryData.data.moic =
        self.dialogSummaryData.data.capital_deployed &&
        Number(self.dialogSummaryData.data.capital_deployed) > 0
          ? (
              Number(self.portfolioValue) /
              self.dialogSummaryData.data.capital_deployed
            ).toFixed(2)
          : 0;
      if (
        !self.dialogSummaryData.data.hasOwnProperty("capital_called_to_date")
      ) {
        self.dialogSummaryData.data.capital_called_to_date = 0;
      }
      self.dialogSummaryData.data.dpi =
        self.dialogSummaryData.data.distributed_to_date &&
        Number(self.dialogSummaryData.data.distributed_to_date) > 0 &&
        self.dialogSummaryData.data.capital_called_to_date &&
        Number(self.dialogSummaryData.data.capital_called_to_date) > 0
          ? (
              Number(self.dialogSummaryData.data.distributed_to_date) /
              Number(self.dialogSummaryData.data.capital_called_to_date)
            ).toFixed(2)
          : 0;
      this.showSummaryModal = true;
    },
    addDetails() {
      const self = this;
      self.dialogDetailsData = {
        isShow: true,
        data: {
          entity_type: "LP",
        },
        isCreate: true,
        detailsData: self.detailsData,
        summaryData:
          self.summaryData && self.summaryData.length > 0
            ? self.summaryData[0]
            : {},
      };
      this.showDetailsModal = true;
    },
    refreshDetailsData() {
      const self = this;
      let data = self.$store.getters["lpAllocations/detailsData"];
      let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
      let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
      let fundData = self.$store.getters["lpAllocations/fundDetailsData"];
      // if (data && data.length > 0) this.detailsTabulator.replaceData(data);
      if (lpData) {
        this.detailsTabulator.replaceData(lpData);
      }
      if (gpData && this.context == "gp") {
        this.gpDetailsTabulator.replaceData(gpData);
      }
      if (fundData && this.context == "gp") {
        this.fundDetailsTabulator.replaceData(fundData);
      }
      this.refreshSummaryData();
      this.showDetailsModal = false;
    },
    editDetails(rowData) {
      const self = this;
      let previousCapital = rowData.hasOwnProperty("capital_called")
        ? rowData.capital_called
        : 0;
      let previousCapitalCalledToDate = rowData.hasOwnProperty(
        "capital_called_to_date"
      )
        ? rowData.capital_called_to_date
        : 0;
      let previousCapitalCommitment = rowData.hasOwnProperty(
        "capital_commitment"
      )
        ? rowData.capital_commitment
        : 0;
      let previousFundCapitalCommitment =
        this.fundDetailsData &&
        this.fundDetailsData.length > 0 &&
        this.fundDetailsData[0] &&
        this.fundDetailsData[0].hasOwnProperty("capital_commitment") &&
        Number(this.fundDetailsData[0].capital_commitment)
          ? Number(this.fundDetailsData[0].capital_commitment)
          : 0;
      self.dialogDetailsData = {
        isShow: true,
        data: JSON.parse(JSON.stringify(rowData)),
        isCreate: false,
        detailsData: self.detailsData,
        summaryData:
          self.summaryData && self.summaryData.length > 0
            ? self.summaryData[0]
            : {},
        previousCapital: previousCapital,
        previousCapitalCalledToDate: previousCapitalCalledToDate,
        previousCapitalCommitment: previousCapitalCommitment,
        previousFundCapitalCommitment: previousFundCapitalCommitment,
      };
      this.showDetailsModal = true;
    },
    handleCancelDeleteDetail() {
      this.showDeleteDetailDialog = false;
      this.showDetailDeleteSpinner = false;
      this.deleteDetailData = {};
    },
    handleDeleteDetail(detailData) {
      const self = this;
      if (detailData._id) {
        this.showDetailDeleteSpinner = true;
        self.$store
          .dispatch("lpAllocations/apiDeleteDetails", detailData)
          .then((deleteData) => {
            self.$store.dispatch("lpAllocations/apiFetchlpDocumentsData");
            self.$store
              .dispatch("lpAllocations/apiFetchDetailsData")
              .then((detailsData) => {
                let newDetailsData =
                  self.$store.getters["lpAllocations/detailsData"];
                let summaryData =
                  self.$store.getters["lpAllocations/summaryData"];
                summaryData =
                  summaryData && summaryData.length > 0 ? summaryData[0] : {};
                if (newDetailsData && newDetailsData.length == 0) {
                  self.handleCancelDeleteDetail();
                  self.$toaster.success("Deleted Successfully");
                } else {
                  self
                    .updateLpDetails(newDetailsData, summaryData)
                    .then((data) => {
                      self
                        .updateDistributionCallData()
                        .then((updateDistributionCallData) => {
                          self
                            .updateDetailsDataDistributions()
                            .then((updateDetailsData) => {
                              self
                                .updateCurrentCapitalCallData()
                                .then((updateCurrentcall) => {
                                  self
                                    .updateSummaryData()
                                    .then((updateSummaryDataResponse) => {
                                      self.refreshDetailsData();
                                      self.handleCancelDeleteDetail();
                                      self.$toaster.success(
                                        "Deleted Successfully"
                                      );
                                    })
                                    .catch((error) => {
                                      console.log(
                                        "error from updateSummaryData in delete detail",
                                        error
                                      );
                                      this.$toaster.error(
                                        "Fail to add Details Data"
                                      );
                                    });
                                })
                                .catch((error) => {
                                  console.log(
                                    "error from updateCurrentCall in delete detail",
                                    error
                                  );
                                  this.$toaster.error(
                                    "Fail to add Details Data"
                                  );
                                });
                            })
                            .catch((error) => {
                              console.log(
                                "error from updateDetailsDataDistributions in delete detail",
                                error
                              );
                              this.$toaster.error("Fail to add Details Data");
                            });
                        })
                        .catch((error) => {
                          console.log(
                            "error from updateDistributionCallData in delete detail",
                            error
                          );
                          this.$toaster.error("Fail to add Details Data");
                        });
                    })
                    .catch((error) => {
                      console.log(
                        "error from bulk calculations in delete detail",
                        error
                      );
                      this.$toaster.error("Fail to add Details Data");
                    });
                }
              })
              .catch((error) => {
                console.log(
                  "error in fetching detail from deleting detail",
                  error
                );
                this.$toaster.error("Failed to Delete !!!");
              });
          })
          .catch((error) => {
            console.log("error in deleting detail", error);
            this.$toaster.error("Failed to Delete !!!");
          });
      }
    },
    shareOfFeesAndDistributionCalculations(detailsData, summaryData) {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (detailsData && detailsData.length > 0) {
          let ownershipLoopValues = 0;
          let gpOwnershipLoopValues = 0;
          detailsData.map((item) => {
            if (
              item.hasOwnProperty("ownership") &&
              Number(item.ownership) > 0
            ) {
              if (item.entity_type == "LP") {
                ownershipLoopValues += Number(item.ownership);
              } else {
                if (item.entity_type == "GP") {
                  gpOwnershipLoopValues += Number(item.ownership);
                }
              }
            }
          });
          detailsData.map((item) => {
            if (
              item.hasOwnProperty("share_of_fees") &&
              item.hasOwnProperty("entity_type")
            ) {
              if (item.entity_type == "LP") {
                if (
                  summaryData &&
                  summaryData.hasOwnProperty("current_call") &&
                  summaryData.current_call == 1
                ) {
                  let ownership =
                    item.hasOwnProperty("ownership") &&
                    item.ownership &&
                    Number(item.ownership) > 0
                      ? Number(item.ownership)
                      : 0;
                  item.share_of_fees =
                    summaryData.hasOwnProperty("management_fees") &&
                    Number(summaryData.management_fees) > 0
                      ? Number(
                          (
                            (Number(ownership) / Number(ownershipLoopValues)) *
                            Number(summaryData.management_fees)
                          ).toFixed(2)
                        )
                      : 0;
                } else {
                  item.share_of_fees = 0;
                }
              } else {
                item.share_of_fees = 0;
              }
            }
            if (
              item.hasOwnProperty("entity_type") &&
              item.hasOwnProperty("distributions") &&
              item.hasOwnProperty("ownership")
            ) {
              let ownership =
                item.hasOwnProperty("ownership") &&
                item.ownership &&
                Number(item.ownership) > 0
                  ? Number(item.ownership)
                  : 0;
              if (
                summaryData &&
                summaryData.hasOwnProperty("distributions") &&
                Number(summaryData.distributions) > 0
              ) {
                if (
                  summaryData.hasOwnProperty("distributed_to_date") &&
                  summaryData.hasOwnProperty("capital_commitment") &&
                  Number(summaryData.distributed_to_date) >
                    Number(summaryData.capital_commitment)
                ) {
                  if (
                    summaryData.hasOwnProperty(
                      "distributions_exceed_to_date"
                    ) &&
                    Number(summaryData.distributions_exceed_to_date) == 1
                  ) {
                    //for the very first time if distributed to date exceeds capital commitment of summary
                    /*
                    let difference=distributed to date - capital commitment of summary
                    let gpshare1=gp's get 20% of difference
                    let lpshare1=100% of (distributed to investors-difference)
                    let lpshare2=80% of (difference-gpshare1)
                    let gpshare2=20% of (difference-gpshare1)
                    distributions for gp=gpshare1+gpshare2
                    distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1+lpshare2))
                    */
                    let difference = Number(
                      (
                        Number(summaryData.distributed_to_date) -
                        Number(summaryData.capital_commitment)
                      ).toFixed(2)
                    );
                    let gpshare1 = Number(
                      ((20 / 100) * Number(difference)).toFixed(2)
                    );
                    let lpshare1 = Number(
                      (
                        Number(summaryData.distributions) - Number(difference)
                      ).toFixed(2)
                    );
                    let lpshare2 = Number(
                      (
                        (80 / 100) *
                        (Number(difference) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    let gpshare2 = Number(
                      (
                        (20 / 100) *
                        (Number(difference) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    item.distributions =
                      item.entity_type == "LP"
                        ? Number(ownership) > 0
                          ? Number(
                              (
                                (Number(ownership) /
                                  Number(ownershipLoopValues)) *
                                (Number(lpshare1) + Number(lpshare2))
                              ).toFixed(2)
                            )
                          : 0
                        : Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(gpOwnershipLoopValues)) *
                              (Number(gpshare1) + Number(gpshare2))
                            ).toFixed(2)
                          )
                        : 0;
                  }
                  //Number(gpshare1) + Number(gpshare2)
                  else {
                    // let gpshare1=(20/100)*distributed to investors of summary
                    // let lpshare1=(80/100)*(distributed to investors of summary-gpshare1)
                    // let gpshare2=(20/100)*(distributed to investors of summary-gpshare1)
                    // distributions for gp=gpshare1+gpshare2
                    // distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1))
                    let gpshare1 = Number(
                      ((20 / 100) * Number(summaryData.distributions)).toFixed(
                        2
                      )
                    );
                    let lpshare1 = Number(
                      (
                        (80 / 100) *
                        (Number(summaryData.distributions) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    let gpshare2 = Number(
                      (
                        (20 / 100) *
                        (Number(summaryData.distributions) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    item.distributions =
                      item.entity_type == "LP"
                        ? Number(ownership) > 0
                          ? Number(
                              (
                                (Number(ownership) /
                                  Number(ownershipLoopValues)) *
                                Number(lpshare1)
                              ).toFixed(2)
                            )
                          : 0
                        : Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(gpOwnershipLoopValues)) *
                              (Number(gpshare1) + Number(gpshare2))
                            ).toFixed(2)
                          )
                        : 0;
                  } //Number(gpshare1) + Number(gpshare2)
                } else {
                  item.distributions =
                    item.entity_type == "LP"
                      ? Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(ownershipLoopValues)) *
                              Number(summaryData.distributions)
                            ).toFixed(2)
                          )
                        : 0
                      : 0;
                }
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    calculateCapitalDeployedOfSummary() {
      const self = this;
      let lpDetailsData = JSON.parse(JSON.stringify(this.lpDetailsData));
      let capitalDeployed = 0;
      lpDetailsData.map((item) => {
        if (
          item.hasOwnProperty("contributed_to_date") &&
          Number(item.contributed_to_date) > 0
        ) {
          capitalDeployed += Number(item.contributed_to_date);
        }
      });
      return capitalDeployed;
    },
    updateLpDetails(detailsData, summaryData) {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        self
          .updateGpDetails(detailsData, summaryData)
          .then((data) => {
            self
              .updateLpOwnership()
              .then((ownershipData) => {
                let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
                let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
                let fundDetails =
                  self.$store.getters["lpAllocations/fundDetailsData"];
                let fundDetailsCapitalCommitment =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("capital_commitment") &&
                  Number(fundDetails[0].capital_commitment)
                    ? Number(fundDetails[0].capital_commitment)
                    : 0;
                let fundDetailsFundPercentage =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("ownership") &&
                  Number(fundDetails[0].ownership)
                    ? Number(fundDetails[0].ownership)
                    : 0;
                if (detailsData && detailsData.length > 0) {
                  let totalLpCommitment = 0;
                  let gpCarry = 0;
                  detailsData.map((item) => {
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "LP"
                    ) {
                      if (
                        item.hasOwnProperty("capital_commitment") &&
                        Number(item.capital_commitment) > 0
                      ) {
                        totalLpCommitment += Number(item.capital_commitment);
                      }
                    }
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "GP Carry"
                    ) {
                      if (
                        item.hasOwnProperty("profit") &&
                        Number(item.profit) > 0
                      ) {
                        gpCarry = Number(item.profit);
                      }
                    }
                  });
                  detailsData.map((item) => {
                    let capitalCommitment =
                      item.hasOwnProperty("capital_commitment") &&
                      Number(item.capital_commitment) > 0
                        ? Number(item.capital_commitment)
                        : 0;
                    let contributedToDate =
                      item.contributed_to_date &&
                      Number(item.contributed_to_date) > 0
                        ? Number(item.contributed_to_date)
                        : 0;
                    item.capital_called =
                      capitalCommitment &&
                      summaryData &&
                      summaryData.hasOwnProperty("capital_called_to_date") &&
                      Number(summaryData.capital_called_to_date) > 0
                        ? Number(
                            (
                              Number(capitalCommitment) *
                              (Number(summaryData.capital_called_to_date) / 100)
                            ).toFixed(2)
                          )
                        : 0;
                    let capitalCalled =
                      item.capital_called && Number(item.capital_called) > 0
                        ? Number(item.capital_called)
                        : 0;
                    if (item.entity_type == "LP") {
                      item.ownership = Number(
                        (
                          (Number(capitalCommitment) /
                            Number(fundDetailsCapitalCommitment)) *
                          100
                        ).toFixed(2)
                      );
                    }
                    let ownership =
                      item.hasOwnProperty("ownership") &&
                      Number(item.ownership) > 0
                        ? Number(item.ownership)
                        : 0;
                    item.lp_percentage =
                      item.entity_type == "LP"
                        ? Number(
                            (
                              (Number(capitalCommitment) /
                                Number(totalLpCommitment)) *
                              100
                            ).toFixed(2)
                          )
                        : 0;
                    if (item.entity_type == "LP" || item.entity_type == "GP") {
                      item.profit = Number(
                        (
                          (Number(Number(fundDetailsFundPercentage) / 100) -
                            Number(Number(gpCarry) / 100)) *
                          Number(ownership)
                        ).toFixed(2)
                      );
                    }
                    item.open_balance = Number(
                      (
                        Number(capitalCalled) - Number(contributedToDate)
                      ).toFixed(2)
                    );
                    item.remaining_commitment = Number(
                      (
                        Number(capitalCommitment) -
                        Number(capitalCalled) +
                        Number(item.open_balance)
                      ).toFixed(2)
                    );
                    if (
                      summaryData &&
                      summaryData.hasOwnProperty("distributions") &&
                      summaryData.hasOwnProperty("distributions_pre_carry") &&
                      summaryData.hasOwnProperty("distributions_in_carry") &&
                      Number(summaryData.distributions) > 0 &&
                      Number(summaryData.distributions_pre_carry) &&
                      Number(summaryData.distributions_in_carry)
                    ) {
                      if (
                        summaryData.hasOwnProperty("distributed_to_date") &&
                        summaryData.hasOwnProperty("capital_commitment") &&
                        Number(summaryData.distributed_to_date) >
                          Number(summaryData.capital_commitment)
                      ) {
                        //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                        item.distributions = Number(
                          (
                            Number(summaryData.distributions_pre_carry) *
                              (Number(ownership) / 100) +
                            Number(summaryData.distributions_in_carry) *
                              (Number(item.profit) / 100)
                          ).toFixed(2)
                        );
                      } else {
                        //distrubutions=distributed to date of summary*ownership%
                        item.distributions =
                          (item.entity_type == "LP" ||
                            item.entity_type == "GP") &&
                          Number(summaryData.distributed_to_date) > 0 &&
                          Number(ownership) > 0
                            ? Number(
                                (
                                  Number(summaryData.distributed_to_date) *
                                  Number(Number(ownership) / 100)
                                ).toFixed(2)
                              )
                            : 0;
                      }
                    }
                    payload.push(item);
                  });
                  self.$store
                    .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
                    .then((data) => {
                      resolve(data);
                    })
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  resolve();
                }
              })
              .catch((error) => {
                this.$toaster.error("Fail to update");
                console.log(
                  "error in updating lp ownership details inside update lp details",
                  error
                );
              });
          })
          .catch((error) => {
            this.$toaster.error("Fail to update");
            console.log(
              "error in updating gp details inside update lp details",
              error
            );
          });
      });
    },
    updateGpDetails(detailsData, summaryData) {
      const self = this;
      let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (detailsData && detailsData.length > 0) {
          let totalLpCommitment = 0;
          let gpCarry = 0;
          detailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP"
            ) {
              if (
                item.hasOwnProperty("capital_commitment") &&
                Number(item.capital_commitment) > 0
              ) {
                totalLpCommitment += Number(item.capital_commitment);
              }
            }
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              if (item.hasOwnProperty("profit") && Number(item.profit) > 0) {
                gpCarry = Number(item.profit);
              }
            }
          });
          gpData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership) > 0
                ? Number(item.ownership)
                : 0;
            if (item.entity_type == "GP") {
              //gp% of lp capital commitment
              item.capital_commitment = Number(
                (
                  Number(Number(item.ownership) / 100) *
                  Number(totalLpCommitment)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  (Number(Number(fundDetailsFundPercentage) / 100) -
                    Number(Number(gpCarry) / 100)) *
                  Number(ownership)
                ).toFixed(2)
              );
              item.remaining_commitment = Number(
                (
                  Number(item.capital_commitment) -
                  Number(item.capital_called) +
                  Number(item.open_balance)
                ).toFixed(2)
              );
            }
            if (
              summaryData &&
              summaryData.hasOwnProperty("distributions") &&
              summaryData.hasOwnProperty("distributions_pre_carry") &&
              summaryData.hasOwnProperty("distributions_in_carry") &&
              Number(summaryData.distributions) > 0 &&
              Number(summaryData.distributions_pre_carry) &&
              Number(summaryData.distributions_in_carry)
            ) {
              if (
                summaryData.hasOwnProperty("distributed_to_date") &&
                summaryData.hasOwnProperty("capital_commitment") &&
                Number(summaryData.distributed_to_date) >
                  Number(summaryData.capital_commitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(summaryData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(summaryData.distributions_in_carry) *
                      (Number(item.profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  item.entity_type == "GP" &&
                  Number(summaryData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(summaryData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpOwnership() {
      const self = this;
      let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (lpData && lpData.length > 0) {
          let totalLpCommitment = 0;
          // lpData.map((item) => {
          //   if (
          //     item &&
          //     item.hasOwnProperty("entity_type") &&
          //     item.entity_type == "LP"
          //   ) {
          //     if (
          //       item.hasOwnProperty("capital_commitment") &&
          //       Number(item.capital_commitment) > 0
          //     ) {
          //       totalLpCommitment += Number(item.capital_commitment);
          //     }
          //   }
          // });
          lpData.map((item) => {
            let capitalCommitment =
              item.hasOwnProperty("capital_commitment") &&
              Number(item.capital_commitment) > 0
                ? Number(item.capital_commitment)
                : 0;
            if (item.entity_type == "LP") {
              item.ownership = Number(
                (
                  (Number(capitalCommitment) /
                    Number(fundDetailsCapitalCommitment)) *
                  100
                ).toFixed(2)
              );
            }
            payload.push(item);
            self.$store
              .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          resolve();
        }
      });
    },
    editGPDetails(rowData) {
      this.editGPDetailsData = JSON.parse(JSON.stringify(rowData));
      this.showEditGPDetailsModal = true;
    },
    handleCancelEditGpDetail() {
      this.showEditGPDetailsModal = false;
      this.showEditGPDetailsSpinner = false;
      this.editGPDetailsData = {};
    },
    handleEditGpDetails() {
      const self = this;
      this.showEditGPDetailsSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.editGPDetailsData));
      serverData.contributed_to_date = Number(serverData.contributed_to_date);
      let capitalCommitment =
        serverData.hasOwnProperty("capital_commitment") &&
        Number(serverData.capital_commitment) > 0
          ? Number(serverData.capital_commitment)
          : 0;
      let contributedToDate =
        serverData.hasOwnProperty("contributed_to_date") &&
        Number(serverData.contributed_to_date) > 0
          ? Number(serverData.contributed_to_date)
          : 0;
      let capitalCalled =
        serverData.hasOwnProperty("capital_called") &&
        Number(serverData.capital_called) > 0
          ? Number(serverData.capital_called)
          : 0;
      serverData.open_balance = Number(
        (Number(capitalCalled) - Number(contributedToDate)).toFixed(2)
      );
      //open balance=total_capital_called of each lp detail-contributed to date of each lp detail
      //remaining commitment=capital commitment of each lp detail-total_capital_called of each lp detail+open balance
      serverData.remaining_commitment = Number(
        (
          Number(capitalCommitment) -
          Number(capitalCalled) +
          Number(serverData.open_balance)
        ).toFixed(2)
      );
      self.$store
        .dispatch("lpAllocations/apiPatchDetailsData", serverData)
        .then((data) => {
          this.refreshDetailsData();
          this.handleCancelEditGpDetail();
          this.$toaster.success("Saved Successfully");
        })
        .catch((error) => {
          console.log("error in gp details edit", error);
          this.$toaster.error("Failed to update!!!");
        });
    },
    updateCurrentCapitalCallData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        if (
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("_id")
        ) {
          let totalLpCapitalCalled = 0;
          let totalLpDistributions = 0;
          let totalFundCapitalCalled =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_called") &&
            Number(fundDetailsData[0].capital_called) > 0
              ? Number(fundDetailsData[0].capital_called)
              : 0;
          let totalFundDistributions =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("distributions") &&
            Number(fundDetailsData[0].distributions) > 0
              ? Number(fundDetailsData[0].distributions)
              : 0;
          let serverData = JSON.parse(JSON.stringify(currentCapitalCallData));
          let previousValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty(
              "capital_called_to_date_amount"
            )
              ? Number(currentCapitalCallData.capital_called_to_date_amount)
              : 0;
          let previouCapitalCalledAmountValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("capital_called_amount")
              ? Number(currentCapitalCallData.capital_called_amount)
              : 0;
          let presentValue = Number(
            (
              Number(previousValue) - Number(previouCapitalCalledAmountValue)
            ).toFixed(2)
          );
          if (lpDetailsData && lpDetailsData.length > 0) {
            lpDetailsData.map((item) => {
              if (
                item &&
                item.hasOwnProperty("capital_called") &&
                Number(item.capital_called) > 0
              ) {
                totalLpCapitalCalled += Number(item.capital_called);
              }
              if (
                item &&
                item.hasOwnProperty("distributions") &&
                Number(item.distributions) > 0
              ) {
                totalLpDistributions += Number(item.distributions);
              }
            });
          }
          serverData.capital_called_amount =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment) > 0
              ? Number(
                  (
                    Number(serverData.capital_called / 100) *
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.capital_called_to_date_amount = Number(
            (
              Number(presentValue) + Number(serverData.capital_called_amount)
            ).toFixed(2)
          );
          serverData.moic =
            Number(this.portfolioValue) > 0 && Number(this.portfolioCost) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(this.portfolioCost)
                  ).toFixed(2)
                )
              : 0;
          serverData.tvpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.net_dpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalLpDistributions) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.gross_dpi =
            Number(totalFundCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalFundDistributions) /
                    Number(totalFundCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          if (serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        let serverData =
          summaryData && summaryData.length > 0
            ? JSON.parse(JSON.stringify(summaryData[0]))
            : {};
        serverData.capital_called =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called") &&
          Number(currentCapitalCallData.capital_called) > 0
            ? Number(currentCapitalCallData.capital_called)
            : 0;
        serverData.capital_called_to_date =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
          Number(currentCapitalCallData.capital_called_to_date) > 0
            ? Number(currentCapitalCallData.capital_called_to_date)
            : 0;
        serverData.capital_called_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_amount") &&
          Number(currentCapitalCallData.capital_called_amount) > 0
            ? Number(currentCapitalCallData.capital_called_amount)
            : 0;
        serverData.capital_called_to_date_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        serverData.current_capital_call =
          currentCapitalCallData && currentCapitalCallData.hasOwnProperty("_id")
            ? currentCapitalCallData._id
            : "";
        serverData.moic =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("moic") &&
          Number(currentCapitalCallData.moic) > 0
            ? Number(currentCapitalCallData.moic)
            : 0;
        serverData.tvpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("tvpi") &&
          Number(currentCapitalCallData.tvpi) > 0
            ? Number(currentCapitalCallData.tvpi)
            : 0;
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        serverData.distributions =
          currentDistributionData.hasOwnProperty("distributions") &&
          Number(currentDistributionData.distributions)
            ? Number(currentDistributionData.distributions)
            : 0;
        serverData.distributions_pre_carry =
          currentDistributionData.hasOwnProperty("distributions_pre_carry") &&
          Number(currentDistributionData.distributions_pre_carry)
            ? Number(currentDistributionData.distributions_pre_carry)
            : 0;
        serverData.distributions_in_carry =
          currentDistributionData.hasOwnProperty("distributions_in_carry") &&
          Number(currentDistributionData.distributions_in_carry)
            ? Number(currentDistributionData.distributions_in_carry)
            : 0;
        serverData.distributed_to_date =
          currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(currentDistributionData.distributed_to_date)
            ? Number(currentDistributionData.distributed_to_date)
            : 0;
        serverData.current_distribution =
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
            ? currentDistributionData._id
            : "";
        if (summaryData && summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    updateDistributionCallData() {
      const self = this;
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        if (
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
        ) {
          let serverData = JSON.parse(JSON.stringify(currentDistributionData));
          serverData.distributed_to_date = serverData.hasOwnProperty(
            "distributed_to_date"
          )
            ? Number(serverData.distributed_to_date)
            : 0;
          serverData.distributions_in_carry =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment)
              ? Number(
                  (
                    Number(serverData.distributed_to_date) -
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.distributions_pre_carry = Number(
            (
              Number(serverData.distributed_to_date) -
              Number(serverData.distributions_in_carry)
            ).toFixed(2)
          );
          self.$store
            .dispatch("lpAllocations/apiPatchDistributionData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateDetailsDataDistributions() {
      const self = this;
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        let capitalCommitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment)
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership)
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit)
                ? Number(item.profit)
                : 0;
            if (
              currentDistributionData &&
              currentDistributionData.hasOwnProperty("distributions") &&
              currentDistributionData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              currentDistributionData.hasOwnProperty(
                "distributions_in_carry"
              ) &&
              Number(currentDistributionData.distributions) > 0 &&
              Number(currentDistributionData.distributions_pre_carry) &&
              Number(currentDistributionData.distributions_in_carry)
            ) {
              if (
                currentDistributionData.hasOwnProperty("distributed_to_date") &&
                capitalCommitment &&
                Number(capitalCommitment) &&
                Number(currentDistributionData.distributed_to_date) >
                  Number(capitalCommitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(currentDistributionData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(currentDistributionData.distributions_in_carry) *
                      (Number(profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  (item.entity_type == "LP" || item.entity_type == "GP") &&
                  Number(currentDistributionData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(currentDistributionData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    toolTipInfo(metric) {
      let data = this.summaryData;
      let retval = "";
      if (metric == "capital_called_amount") {
        if (
          data &&
          data.length > 0 &&
          data[0].hasOwnProperty("capital_called_amount") &&
          Number(data[0].capital_called_amount) > 0
        ) {
          retval = `Last $ Capital Called : $${this.precisionNumberForamtter(
            Number(data[0].capital_called_amount),
            1
          )}`;
        } else {
          retval = `Last $ Capital Called : $0`;
        }
      } else {
        if (metric == "capital_called_to_date_amount") {
          if (
            data &&
            data.length > 0 &&
            data[0].hasOwnProperty("capital_called_to_date_amount") &&
            Number(data[0].capital_called_to_date_amount) > 0
          ) {
            retval = `Capital Called to Date : $${this.precisionNumberForamtter(
              Number(data[0].capital_called_to_date_amount),
              1
            )}`;
          } else {
            retval = `Capital Called to Date : $0`;
          }
        }
      }
      return retval;
    },
    precisionNumberForamtter: precisionNumberForamtter,
    getFundKpi() {
      let self = this;
      return new Promise((resolve, reject) => {
        api
          .get(`${self.$route.params.workspace_id}/fundKpi`, {})
          .then((data) => {
            self.fundKpiData = data.data.encrypt.success;
            resolve();
          })
          .catch((error) => {
            console.log("error in getFundKpi", error);
            reject(error);
          });
      });
    },
    handleCancelFundKpi() {
      this.updateFundKpiData = {};
      this.showUpdateFundKpiModal = false;
      this.showUpdateFundKpiSpinner = false;
    },
    handleUpdateFundKpi() {
      this.updateFundKpiData =
        this.fundKpiData && this.fundKpiData.length > 0
          ? JSON.parse(JSON.stringify(this.fundKpiData[0]))
          : {};
      this.showUpdateFundKpiModal = true;
    },
    handleSaveUpdateFundKpi() {
      let self = this;
      this.showUpdateFundKpiSpinner = true;
      let serverData = {};
      serverData.fund_dpi =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_dpi") &&
        Number(this.updateFundKpiData.fund_dpi) > 0
          ? Number(this.updateFundKpiData.fund_dpi)
          : 0;
      serverData.fund_exits =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_exits") &&
        Number(this.updateFundKpiData.fund_exits) > 0
          ? Number(this.updateFundKpiData.fund_exits)
          : 0;
      serverData.fund_irr =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_irr") &&
        Number(this.updateFundKpiData.fund_irr) > 0
          ? Number(this.updateFundKpiData.fund_irr)
          : 0;
      serverData.fund_moic =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_moic") &&
        Number(this.updateFundKpiData.fund_moic) > 0
          ? Number(this.updateFundKpiData.fund_moic)
          : 0;
      serverData.fund_no_of_companies =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_no_of_companies") &&
        Number(this.updateFundKpiData.fund_no_of_companies) > 0
          ? Number(this.updateFundKpiData.fund_no_of_companies)
          : 0;
      serverData.fund_size =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_size") &&
        Number(this.updateFundKpiData.fund_size) > 0
          ? Number(this.updateFundKpiData.fund_size)
          : 0;
      serverData.fund_tvpi =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_tvpi") &&
        Number(this.updateFundKpiData.fund_tvpi) > 0
          ? Number(this.updateFundKpiData.fund_tvpi)
          : 0;
      serverData.fund_value_of_portfolio =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_value_of_portfolio") &&
        Number(this.updateFundKpiData.fund_value_of_portfolio) > 0
          ? Number(this.updateFundKpiData.fund_value_of_portfolio)
          : 0;
      serverData.fund_distributed =
        this.updateFundKpiData &&
        this.updateFundKpiData.hasOwnProperty("fund_distributed") &&
        Number(this.updateFundKpiData.fund_distributed) > 0
          ? Number(this.updateFundKpiData.fund_distributed)
          : 0;
      api
        .post(
          `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/fund_data`,
          {
            encrypt: {
              data: serverData,
            },
          }
        )
        .then((data) => {
          self
            .getFundKpi()
            .then((fundKpiData) => {
              self.handleCancelFundKpi();
              self.$toaster.success("Saved Successfully.");
            })
            .catch((error) => {
              console.log("error in getting fund kpi in update kpi", error);
              self.$toaster.error("Fail to update!!!");
            });
        })
        .catch((error) => {
          console.log("error in handleSaveUpdateFundKpi", error);
          self.handleCancelFundKpi();
          self.$toaster.error("Fail to update!!!");
        });
    },
  },
};
</script>
<style lang=scss>
.lpMainDiv {
  padding-top: 15px;
  padding-bottom: 15px;
}

.lp-tabulator-cls
  .tabulator-header
  .tabulator-headers
  .tabulator-col
  .tabulator-col-content
  .tabulator-col-title {
  line-height: 15px;
}

.summaryFundCardLayout {
  height: 200px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
}

.distributionTableLayout {
  table-layout: fixed;
  width: 75%;
  td {
    text-align: right;
  }
}
</style>